import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={25}
    height={22}
    viewBox={'0 0 25 22'}
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#f90'}
      d="M17.91.979c-3.79 0-5.44 3.45-5.44 3.45-.34-.64-.77-1.22-1.29-1.73A5.828 5.828 0 0 0 7.038.969c-3.79 0-6.93 3.09-6.24 7.71.69 4.62 5.31 8.43 11.67 12.58 3.18-2.07 5.92-4.06 7.96-6.11 2.04-2.05 3.36-4.16 3.71-6.47.69-4.62-2.45-7.71-6.24-7.71l.01.01Z"
    />
  </Svg>
);
export default SvgComponent;
